import React from 'react';
import classnames from 'classnames';
import PresenterDetails from '../../PresenterDetails';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import {getSelectedOptionLabel} from '../../../utils/options';
import {formattingDate} from '../../../utils/formatting';
import styles from './styles.module.scss';

const ShumaType3Section2Text = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {
    visitDate,
    visitorName,
    visitorJob,
  } = context.data.pdfData;
  const visitorJobValue = getSelectedOptionLabel(visitorJob, context.options.visitorJobOptions);
  const visitorNameAndJob = `${visitorName}, ${visitorJobValue}`;
  const visitDateValue = Boolean(visitDate) ? formattingDate(visitDate) : '';

  return (
    <div
      className={classnames(styles.itemText, styles.innerPadding, styles.lastSectionLine)}
      ref={ref}
    >
      <span>
       בתאריך {visitDateValue} נערך ביקור בנכס ובסביבתו
      ע"י {visitorNameAndJob}
      </span>
      <PresenterDetails/>
    </div>
  );
});

export default ShumaType3Section2Text;
